import { Component, OnInit } from '@angular/core';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

@Component({
  selector: 'app-liquidations',
  templateUrl: './liquidations.component.html',
  styleUrls: ['./liquidations.component.css']
})
export class LiquidationsComponent implements OnInit {

  displayedColumns: string[] = ['id', 'fecha', 'total', 'neto', 'commision', 'liquidacion', 'pdf'];
  dataSource = ELEMENT_DATA;

  generarPDF(){
    const doc = new jsPDF()
    doc.setFontSize(18);
    doc.text('Reporte de Ventas', 11, 8);
    doc.setFontSize(11);
    doc.setTextColor(100);
    
    doc.save("sales.pdf");
  }

  constructor() { }

  ngOnInit(): void {
  }

}
export interface Liquidaciones {
  id: string,
  fecha: string,
  total: string,
  neto: string,
  commision: string,
  liquidacion: string,
  pdf: string,
}

const ELEMENT_DATA: Liquidaciones[] = [
  { id: '', fecha: '', total: '', neto: '', commision: '', liquidacion: '', pdf: '' }
];
